import { createApi } from '@reduxjs/toolkit/query/react';

import { apiWeeklyPlanner } from '~constants/api';

import { Response, rtkBaseQueryWrapper } from '~libs/axiosWrapper';
import { UnallocatedAppointment, Worker } from '~weekly-planner/lib/common';

export const typePrefix = 'weekly-planner-visualise';

export const visualiseApi = createApi({
  reducerPath: 'weeklyPlannerVisualiseApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiWeeklyPlanner }),
  endpoints: (builder) => ({
    visualiseDistance: builder.mutation<Response<Worker>, { worker: Worker; appointment: UnallocatedAppointment }>({
      query: (body) => ({ url: '/visualise/distance', method: 'PUT', body }),
    }),
  }),
});

export const { useVisualiseDistanceMutation } = visualiseApi;
